import { useEffect } from 'react'
import { Box, Autocomplete, TextField } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import { useForm, Controller } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { useTranslation } from 'react-i18next'

const KybSelectFieldModal = ({ name, initialValue, onSubmit, options = [], labelKey = 'label' }) => {
  const { t } = useTranslation(['common'])

  const schema = yup.object().shape({
    value: yup.object().required(t('common:required')),
  })

  const {
    control,
    handleSubmit,
    setValue,
    formState: { isDirty, isValid },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(schema),
    defaultValues: {
      value: null,
    },
  })

  useEffect(() => {
    if (initialValue) {
      const match = options.find((opt) => opt.id === initialValue?.id)
      setValue('value', match || null, { shouldDirty: false })
    }
  }, [initialValue, options, setValue])

  const handleFormSubmit = ({ value }) => {
    onSubmit('legalRepresentative', value.name)
    onSubmit('legalRepresentativeDocumentNumber', value.documentNumber)
    onSubmit('legalRepresentativeLabel', value.customLabel)
  }

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)}>
      <Box className="modal-box">
        <Controller
          name="value"
          control={control}
          render={({ field }) => (
            <Autocomplete
              {...field}
              fullWidth
              options={options}
              getOptionLabel={(option) => option[labelKey] || ''}
              onChange={(_, data) => field.onChange(data)}
              isOptionEqualToValue={(option, value) => option?.id === value?.id}
              sx={{
                '& .MuiOutlinedInput-root': {
                  overflowX: 'auto',
                },
                '& input': {
                  fontSize: '0.75rem',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                },
              }}
              ListboxProps={{
                style: {
                  maxHeight: 200,
                  overflowY: 'auto',
                },
              }}
              renderOption={(props, option) => (
                <li
                  {...props}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    paddingRight: '1rem',
                    fontSize: '0.75rem',
                  }}
                >
                  {option.label}
                </li>
              )}
              renderInput={(params) => <TextField {...params} placeholder={t(`common:${name}`)} variant="outlined" />}
            />
          )}
        />
      </Box>
      <Box className="modal-button">
        <LoadingButton size="small" color="secondary" variant="contained" disabled={!isDirty || !isValid} type="submit">
          {t('common:save')}
        </LoadingButton>
      </Box>
    </form>
  )
}

export default KybSelectFieldModal
